export default __webpack_public_path__ + "static/results-light-395ce73497576e00cb9c3db8c1799d51.png";